(function () {
    'use strict';
    $(document).ready(function () {

        $(".play-video").modalVideo();

        const strategySwiper = new Swiper('.swiper.strategy-swiper', {
            spaceBetween: 100,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: '.strategy-main .swiper-button-next',
                prevEl: '.strategy-main .swiper-button-prev',
            },
        });

        const sliderSwiper = new Swiper('.swiper.slider-swiper', {
            spaceBetween: 100,
            pagination: {
                el: ".swiper-pagination2",
                clickable: true,
            },
            navigation: {
                nextEl: '.slider-main .swiper-button-next',
                prevEl: '.slider-main .swiper-button-prev',
            },
        });
    });
}(jQuery));
